import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "task",
  "use": "task-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"task\"><path fill-rule=\"evenodd\" d=\"m8.8 15.9-4.2-4.2-1.4 1.4 5.6 5.6 12-12-1.4-1.4z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol